// Auto-generated imports for web dependencies
import "highlightjs-copy";
import "@fortawesome/fontawesome-free/css/fontawesome.css";
import "@fortawesome/fontawesome-free";
import "highlight.js";

// Auto-generated imports for project sources
export * from "./web/app/guide-toc-scroll";
import "./web/app/main.css";
export * from "./web/app/main";
export * from "./web/app/plantuml";
import "./web/app/scss/asciidoctor.scss";

